import { render, staticRenderFns } from "./WhatsAppSetting.vue?vue&type=template&id=36bbc226&scoped=true&"
import script from "./WhatsAppSetting.vue?vue&type=script&lang=js&"
export * from "./WhatsAppSetting.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppSetting.vue?vue&type=style&index=0&id=36bbc226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbc226",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VForm,VRow})
